export default __webpack_public_path__ + "static/media/social-support.71c69044.png";